import React from 'react';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import Img from 'gatsby-image';

import { Section, Container } from '../global';
import { isSalonzone } from '../../../../utils';

const Features = () => {
  const data = useStaticQuery(graphql`
    query {
      img1: file(sourceInstanceName: { eq: "product" }, name: { eq: "bc1" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      img2: file(sourceInstanceName: { eq: "product" }, name: { eq: "bc2" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      img3: file(sourceInstanceName: { eq: "product" }, name: { eq: "bc3" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      sCimg1: file(sourceInstanceName: { eq: "product" }, name: { eq: "sc1" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      sCimg2: file(
        sourceInstanceName: { eq: "product" }
        name: { eq: "sc2_flip" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      sCimg3: file(sourceInstanceName: { eq: "product" }, name: { eq: "sc3" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  `);
  return (
    <Section id="features">
      <StyledContainer>
        <SectionTitle>
          <FormattedMessage id="featuresTitle" />
        </SectionTitle>
        <FeaturesGrid>
          <ImageWrapper>
            <StyledImage
              left
              fluid={
                isSalonzone
                  ? data.sCimg1.childImageSharp.fluid
                  : data.img1.childImageSharp.fluid
              }
            />
          </ImageWrapper>
          <FeatureItem>
            <FormattedMessage
              id="features1"
              values={{
                FeatureTitle: (...chunks) => (
                  <FeatureTitle>{chunks}</FeatureTitle>
                ),
                FeatureText: (...chunks) => <FeatureText>{chunks}</FeatureText>,
              }}
            />
            <FormattedMessage
              id="features2"
              values={{
                FeatureTitle: (...chunks) => (
                  <FeatureTitle>{chunks}</FeatureTitle>
                ),
                FeatureText: (...chunks) => <FeatureText>{chunks}</FeatureText>,
              }}
            />
          </FeatureItem>
        </FeaturesGrid>
        <FeaturesGrid>
          <FeatureItem>
            <FormattedMessage
              id="features3"
              values={{
                FeatureTitle: (...chunks) => (
                  <FeatureTitle>{chunks}</FeatureTitle>
                ),
                FeatureText: (...chunks) => <FeatureText>{chunks}</FeatureText>,
              }}
            />
            <FormattedMessage
              id="features4"
              values={{
                FeatureTitle: (...chunks) => (
                  <FeatureTitle>{chunks}</FeatureTitle>
                ),
                FeatureText: (...chunks) => <FeatureText>{chunks}</FeatureText>,
              }}
            />
          </FeatureItem>
          <ImageWrapper>
            <StyledImage
              fluid={
                isSalonzone
                  ? data.sCimg2.childImageSharp.fluid
                  : data.img2.childImageSharp.fluid
              }
            />
          </ImageWrapper>
        </FeaturesGrid>
        <FeaturesGrid>
          <ImageWrapper>
            <StyledImage
              left
              fluid={
                isSalonzone
                  ? data.sCimg3.childImageSharp.fluid
                  : data.img3.childImageSharp.fluid
              }
            />
          </ImageWrapper>
          <FeatureItem>
            <FormattedMessage
              id="features5"
              values={{
                FeatureTitle: (...chunks) => (
                  <FeatureTitle>{chunks}</FeatureTitle>
                ),
                FeatureText: (...chunks) => <FeatureText>{chunks}</FeatureText>,
              }}
            />
            <FormattedMessage
              id="features6"
              values={{
                FeatureTitle: (...chunks) => (
                  <FeatureTitle>{chunks}</FeatureTitle>
                ),
                FeatureText: (...chunks) => <FeatureText>{chunks}</FeatureText>,
              }}
            />
          </FeatureItem>
        </FeaturesGrid>
      </StyledContainer>
    </Section>
  );
};

export default Features;

const StyledContainer = styled(Container)`
  padding: 20px 0 0px;
`;

const SectionTitle = styled.h3`
  color: ${(props) => props.theme.color.primary};
  display: flex;
  justify-content: center;
  margin: 0 auto 40px;
  text-align: center;
`;

const FeaturesGrid = styled.div`
  max-width: 670px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0px auto;
  grid-column-gap: 40px;
  grid-row-gap: 35px;
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    padding: 0 64px;
  }
`;

const FeatureItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
`;

const FeatureText = styled.p`
  text-align: center;
`;

const ImageWrapper = styled.div`
  justify-self: end;
  align-self: center;
  @media (max-width: ${(props) => props.theme.screen.md}) {
    justify-self: center;
  }
`;

// CSS clipping from https://bennettfeely.com/clippy/
const StyledImage = styled(Img)`
  ${(props) =>
    props.left
      ? `
      -webkit-clip-path: polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%);
      clip-path: polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%);
  `
      : `
      -webkit-clip-path: polygon(25% 0%, 100% 1%, 100% 100%, 25% 100%, 0% 50%);
      clip-path: polygon(25% 0%, 100% 1%, 100% 100%, 25% 100%, 0% 50%);
  `}
  /* ${(props) =>
    props.left
      ? `
    -webkit-clip-path: polygon(0 0, 80% 0%, 100% 100%, 0% 100%);
    clip-path: polygon(0 0, 80% 0%, 100% 100%, 0% 100%);
  `
      : `
    -webkit-clip-path: polygon(15% 0, 100% 0, 100% 100%, 0 100%);
    clip-path: polygon(15% 0, 100% 0, 100% 100%, 0 100%);
  `} */
  margin-top: 40px;
  width: 315px;
  @media (max-width: ${(props) => props.theme.screen.md}) {
    width: 315px;
  }
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    width: 200px;
    display: none;
  }
`;

export const FeatureTitle = styled.h4`
  color: ${(props) => props.theme.color.primary};
  letter-spacing: 0px;
  line-height: 30px;
  margin-bottom: 20px;
  margin-top: 40px;
  text-align: center;
`;
